import { Text } from '@chakra-ui/react';
import { hideString, parseDateTime } from '../../../../services/Utils';
import { useMemo } from 'react';

const GiveawayLogItem = ({ log }) => {
  const isVisible = false;

  const isTest = log?.payload?.isTest;

  const actionLabels = {
    create: 'created',
    c: 'deleted',
    edit: 'edited',
    generate: 'generated',
  };

  const { rawFirstName, rawLastName, title } = useMemo(() => {
    const action = log?.action;

    let rawFirstName;
    let rawLastName;
    let title;

    if (action === 'generate') {
      rawFirstName =
        log?.payload?.prize?.winner?.firstName ||
        log?.payload?.winner?.firstName;
      rawLastName =
        log?.payload?.prize?.winner?.lastName || log?.payload?.winner?.lastName;
      title = log?.payload?.prize?.title;
    } else if (action === 'edit' || action === 'delete') {
      rawFirstName = log?.payload?.winner?.firstName;
      rawLastName = log?.payload?.winner?.lastName;
      title = log?.payload?.title;
    } else if (action === 'create') {
      rawFirstName = log?.payload?.winner?.firstName;
      rawLastName = log?.payload?.winner?.lastName;
      title = log?.payload?.title;
    }

    if (title === undefined || title === null) {
      title = 'NO DATA';
    }

    return { rawFirstName, rawLastName, title };
  }, [log]);

  // Special case for giveaway_closed action
  if (log.action === 'giveaway_closed') {
    return (
      <Text variant="text">
        {`${log.username}: giveaway entries closed in ${parseDateTime(
          log.createdAt
        )}`}
      </Text>
    );
  }

  const noNameData =
    (rawFirstName === undefined || rawFirstName === null) &&
    (rawLastName === undefined || rawLastName === null);

  const firstName = noNameData
    ? 'NO DATA'
    : hideString(rawFirstName || '', isVisible);
  const lastName = noNameData
    ? null
    : hideString(rawLastName || '', isVisible, 0);

  const fullName = lastName ? `${firstName} ${lastName}` : firstName;

  return (
    <Text variant="text">
      {`${log.email} ${actionLabels[log.action] || log.action} ${
        isTest ? 'test' : ''
      } winner (${fullName}) for ${title} on ${parseDateTime(log.createdAt)}`}
    </Text>
  );
};

export default GiveawayLogItem;
